<div class="steps-container">
  @if (step === 0) {
  <div class="step-title">Select Project</div>
  <div class="step-subtitle">Choose a project to upload mission data.</div>
  <app-new-mission (missionCreate)="onMissionCreate($event)"></app-new-mission>
  } @else if (step === 1 && missionCreationResult) {


  @if(uploadView ==='select') {
  <div class="step-title">Upload Data Sets</div>
  <div class="step-subtitle">
    Choose files and folders from your mission to upload to Terabase.
  </div>
  <button tbs-button tbsSize="large" class="mt-1" (click)="uploadView = 'upload'">Choose Files</button>

  <button tbs-button tbsType="ghost" tbsSize="large" class="mt-1" (click)="uploadView = 's3Url'">Choose Server
    Location</button>
  }


  @if(uploadView ==='s3Url') {
  <div class="step-title">Reference Data Sets</div>
  <div class="step-subtitle">
    Provide S3 Folder URL to reference Data Sets you want to process.
  </div>
  <app-s3-url-upload [missionCreationResult]="missionCreationResult" (s3UploadFinish)="onS3UploadFinish()"></app-s3-url-upload>

  }


  @if(uploadView === 'upload') {
  <div class="step-title">Upload Data Sets</div>
  <div class="step-subtitle">
    Choose files and folders from your mission to upload to Terabase.
  </div>
  <app-upload-mission [missionCreationResult]="missionCreationResult"
    (uploadFinish)="onUploadFinish($event)"></app-upload-mission>
  }


  } @else if (step === 2 && missionCreationResult && missionUploadResult) {
  <div class="step-title">Mission Data Upload Complete</div>
  <div class="step-subtitle">
    Your files have been successfully uploaded to Terabase.
  </div>
  <app-mission-result [missionUploadResult]="missionUploadResult"
    [missionCreationResult]="missionCreationResult"></app-mission-result>
  }
</div>